module.exports = __webpack_public_path__ + "img/dashboard.78de48c0.svg";